<template>
  <b-modal id="rewardCheckOutModal"
           title="Check Out"
           :ok-title="okTitle"
           :ok-only="okOnly"
           :ok-disabled="okDisabled"
           @show="show"
           size="lg"
           @ok = "placeOrder"
  >
    <div v-show="step==='input'">
      <b-form>
        <b-form-group horizontal
                      :label-cols="3"
                      label-size="sm"
                      label="First Name :"
                      :state = "invalidFirstName === '' "
                      :invalid-feedback= "invalidFirstName">
          <b-form-input v-model="contact.FirstName" size="sm"/>
        </b-form-group>
        <b-form-group horizontal
                      :label-cols="3"
                      label-size="sm"
                      label="Last Name :"
                      :state = "invalidLastName === '' "
                      :invalid-feedback= "invalidLastName">
          <b-form-input v-model="contact.LastName" size="sm"/>
        </b-form-group>
        <b-form-group horizontal
                      :label-cols="3"
                      label-size="sm"
                      label="Company :"
                      :state = "invalidCompany === '' "
                      :invalid-feedback= "invalidCompany">
          <b-form-input v-model="contact.Company" size="sm"/>
        </b-form-group>
        <b-form-group horizontal
                      :label-cols="3"
                      label-size="sm"
                      label="Address Name :"
                      :state = "invalidAddressLine === '' "
                      :invalid-feedback= "invalidAddressLine">
          <b-form-input v-model="contact.AddressLine" size="sm"/>
        </b-form-group>
        <b-form-group horizontal
                      :label-cols="3"
                      label-size="sm"
                      label="City :"
                      :state = "invalidCity === '' "
                      :invalid-feedback= "invalidCity">
          <b-form-input v-model="contact.City" size="sm"/>
        </b-form-group>
        <b-form-group horizontal
                      :label-cols="3"
                      label-size="sm"
                      label="State :"
                      :state = "invalidState === '' "
                      :invalid-feedback= "invalidState">
          <b-form-input v-model="contact.State" size="sm"/>
        </b-form-group>
        <b-form-group horizontal
                      :label-cols="3"
                      label-size="sm"
                      label="ZIP :"
                      :state = "invalidZIP === '' "
                      :invalid-feedback= "invalidZIP">
          <b-form-input v-model="contact.Zipcode" size="sm"/>
        </b-form-group>
        <b-form-group horizontal
                      :label-cols="3"
                      label-size="sm"
                      label="Telphone :"
                      :state = "invalidPhone === '' "
                      :invalid-feedback= "invalidPhone">
          <b-form-input v-model="contact.Phone" size="sm"/>
        </b-form-group>
      </b-form>

      <h2>Rewards</h2>

      <div class="table-box">
        <table class="table">
          <thead>
          <td class="th-title">Rewards</td>
          <td class="th-title">Quantity</td>
          <td class="th-title">Total Points</td>
          </thead>

          <tr v-for="item of carts">
            <td>{{item.GiftName}}</td>
            <td>{{item.DesiredQuantity | numberFormat('', 0)}}</td>
            <td>{{item.DesiredQuantity * item.PointForOne | numberFormat('', 0)}}</td>
          </tr>
          <tr>
            <td class="th-title">Total Cost</td>
            <td></td>
            <td class="th-title">{{cartPoint | numberFormat('', 0)}}</td>
          </tr>
        </table>
      </div>
    </div>
    <div v-show="step==='success'">
      <p>Your rewards have been confirmed! We have received your redemption order and have started the fulfillment process. You can expect to receive your rewards within the next 7 business days.</p>
      <p>f you have any questions, please contact Us and reference Rewards Order <span class="order-code">{{orderCode}}</span>. Thank you for being part of our Loyalty Program.</p>
    </div>
  </b-modal>

</template>

<script>
  export default {
    components: {
    },
    created () {

    },
    data () {
      return {
        step: 'input',
        okTitle: 'Place Order',
        okOnly: false,
        okDisabled: false,
        orderCode: '',
        contact: {
          AddToMailingList: false,
          AddressLine: '',
          CallMe: false,
          City: '',
          Company: '',
          CountryCode: 'US',
          Email: '',
          FirstName: '',
          IsContactMeByEmail: false,
          IsSendEmailToAudience: false,
          IsSendEmailToList: false,
          IsSendMobileFacebookToAudience: false,
          LastName: '',
          OrderForClients: false,
          OrderName: '',
          Phone: '',
          State: '',
          Zipcode: ''
        }
      }
    },
    computed: {
      histories () {
        return this.$store.state.reward.histories
      },
      point () {
        return this.$store.state.reward.point
      },
      carts () {
        return this.$store.state.reward.carts
      },
      cartPoint () {
        return this.$store.getters['reward/cartPoint']
      },
      invalidFirstName () {
        if (this.contact.FirstName.length === 0) {
          return "It's required"
        } else {
          return ''
        }
      },
      invalidLastName () {
        if (this.contact.LastName.length === 0) {
          return "It's required"
        } else {
          return ''
        }
      },
      invalidCompany () {
        if (this.contact.Company.length === 0) {
          return "It's required"
        } else {
          return ''
        }
      },
      invalidAddressLine () {
        if (this.contact.AddressLine.length === 0) {
          return "It's required"
        } else {
          return ''
        }
      },
      invalidCity () {
        if (this.contact.City.length === 0) {
          return "It's required"
        } else {
          return ''
        }
      },
      invalidState () {
        if (this.contact.State.length !== 2) {
          return 'Need State Code'
        } else {
          return ''
        }
      },
      invalidZIP () {
        if (this.contact.Zipcode.length !== 5) {
          return 'Need ZIP Code'
        } else {
          return ''
        }
      },
      invalidPhone () {
        if (this.contact.Phone.length === 0) {
          return "It's required"
        } else {
          return ''
        }
      }
    },
    watch: {
    },
    methods: {
      show () {
        this.step = 'input'
        this.okTitle = 'Place Order'
        this.okOnly = false
        this.$http.post('ba/RewardCart.aspx/GetCart', {}
        ).then(resp => {
          let data = resp.body.d.DataSource
          let user = data.User
          this.contact.FirstName = user.FirstName
          this.contact.LastName = user.LastName
          this.contact.Company = user.Company
          this.contact.AddressLine = user.UsersAddress[0].AddressLine
          this.contact.City = user.UsersAddress[0].CityName
          this.contact.State = user.UsersAddress[0].StateCode
          this.contact.Zipcode = user.UsersAddress[0].ZipCode
          this.contact.Phone = user.HomePhone
        })
      },
      placeOrder (evt) {
        evt.preventDefault()
        if (this.step === 'success') {
          this.$root.$emit('bv::hide::modal', 'rewardCheckOutModal')
          return
        }
        if (this.invalidFirstName !== '') { return }
        if (this.invalidLastName !== '') { return }
        if (this.invalidCompany !== '') { return }
        if (this.invalidAddressLine !== '') { return }
        if (this.invalidCity !== '') { return }
        if (this.invalidState !== '') { return }
        if (this.invalidZIP !== '') { return }
        if (this.invalidPhone !== '') { return }
        this.okDisabled = true
        this.$http.post('ba/Reward.aspx/RedeemCartOrder', {
          contact: this.contact,
          cart: {
            Items: this.carts
          }
        }).then(resp => {
          this.step = 'success'
          this.okTitle = 'Close'
          this.okOnly = true
          this.okDisabled = false
          let data = resp.body.d.DataSource
          this.orderCode = data.OrderCode
          this.$store.commit('reward/saveKey', ['point', data.UserPoint])
          this.$store.commit('reward/saveKey', ['carts', []])
        }, resp => {
          this.okDisabled = false
        })
      }
    }
  }
</script>

<style scoped lang="scss">
.table {
  border: 1px solid #ccc;

}
.table-box {
  max-height: 300px;
  overflow-y: auto;
}
.point-box {
  margin-bottom: 24px;
}
.order-code {
  color: $color-primary;
}
</style>




// WEBPACK FOOTER //
// src/components/reward/MRewardCheckOut.vue